module.exports = __webpack_public_path__ + "static/media/2023.ea5c7f3d.png";